import { memo, useMemo } from 'react';
import { ChevronDown, type LucideIcon } from 'lucide-react';
import { Button, Dropdown, type DropdownItem } from '@cyphex/ui';
import type { DeviceInfo } from '../../media/contract';

export interface DeviceMenuProps {
  label: string;
  icon: LucideIcon;
  devices: readonly DeviceInfo[];
  selectedId: string | undefined;
  onSelect: (deviceId: string) => void;
}

/** Device picker built from the Dropdown primitive — no bespoke select. */
export const DeviceMenu = memo(function DeviceMenu({
  label, icon, devices, selectedId, onSelect,
}: DeviceMenuProps) {
  const items = useMemo<readonly DropdownItem[]>(
    () =>
      devices.map((device) => ({
        id: device.deviceId,
        label: device.label,
        checked: device.deviceId === selectedId,
        onSelect: () => onSelect(device.deviceId),
      })),
    [devices, selectedId, onSelect],
  );

  const current = devices.find((device) => device.deviceId === selectedId) ?? devices[0];

  return (
    <Dropdown
      align="start"
      items={items.length > 0 ? items : [{ id: 'none', label: 'No devices found', disabled: true }]}
      label={label}
      trigger={
        <Button variant="outline-neutral" size="md" fullWidth leftIcon={icon} rightIcon={ChevronDown}>
          <span className="min-w-0 flex-1 truncate text-left">{current?.label ?? label}</span>
        </Button>
      }
    />
  );
});
